import React from 'react';
import { MinusIcon, PlusIcon, ShoppingCartIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { useStore } from '../../lib/store';
import { haptics } from '../../lib/utils/haptics';
interface StickyBottomActionsProps {
  product: {
    id: string | number;
    name: string;
    price: number;
    images: string[];
    brand?: string;
    inStock: boolean;
  };
  isNow?: boolean;
}
export function StickyBottomActions({
  product,
  isNow = false
}: StickyBottomActionsProps) {
  const navigate = useNavigate();
  const productId = typeof product.id === 'string' ? parseInt(product.id) : product.id;
  const {
    cart,
    addToCart,
    updateQuantity
  } = useStore();
  const cartItem = cart.find(item => item.id === productId);
  const quantity = cartItem?.quantity ?? 0;
  const isInCart = quantity > 0;
  const addProduct = () => {
    haptics.success();
    addToCart({
      id: productId,
      name: product.name,
      price: product.price,
      image: product.images[0],
      brand: product.brand
    });
    toast.success(`${product.name} added to cart`);
  };
  const increaseQuantity = () => {
    haptics.light();
    updateQuantity(productId, quantity + 1);
  };
  const decreaseQuantity = () => {
    haptics.light();
    updateQuantity(productId, quantity - 1);
  };
  if (isNow) {
    return <div className="fixed inset-x-0 bottom-[68px] z-40 border-t border-brand-border bg-white shadow-[0_-4px_18px_rgba(52,52,52,0.08)] lg:hidden" data-id="element-4953" data-mp="3i8tej106lbb2">
        <div className="px-4 py-3" data-id="element-4954" data-mp="3s5pprehgsbjb">
          {!isInCart ? <button type="button" onClick={addProduct} disabled={!product.inStock} className="flex h-12 w-full items-center justify-center gap-2 rounded-lg bg-brand px-4 text-sm font-bold text-white transition-[background-color,box-shadow] duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-gray-300" data-id="element-4955" data-mp="3s33h1biu7pzi">
              <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-4956" data-mp="lrddw0zoqoiu" />
              Add to cart · SAR {product.price.toFixed(2)}
            </button> : <div className="grid grid-cols-[1fr_1.15fr] gap-3" data-id="element-4957" data-mp="vpt6k8ed25ug">
              <motion.div initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.16,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex items-center rounded-lg border border-brand bg-brand-light text-brand" data-id="element-4958" data-mp="10imdn2xaxq9p">
                <button type="button" onClick={decreaseQuantity} className="flex h-12 flex-1 items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand" aria-label="Decrease quantity" data-id="element-4959" data-mp="1ej6vnwve7i25">
                  <MinusIcon className="h-5 w-5" aria-hidden="true" data-id="element-4960" data-mp="3l8brbcm9r60t" />
                </button>
                <span className="min-w-9 border-x border-brand-border px-2 text-center text-sm font-bold" data-id="element-4961" data-mp="3dou15geirhva">{quantity}</span>
                <button type="button" onClick={increaseQuantity} className="flex h-12 flex-1 items-center justify-center focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand" aria-label="Increase quantity" data-id="element-4962" data-mp="38xkcoj4pikkz">
                  <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-4963" data-mp="2z1r1b32q4x4s" />
                </button>
              </motion.div>
              <button type="button" onClick={() => navigate('/cart?mode=now')} className="h-12 rounded-lg bg-brand px-4 text-sm font-bold text-white transition-colors duration-150 hover:bg-brand-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2" data-id="element-4964" data-mp="fxy3ddtvx7j">
                View cart
              </button>
            </div>}
        </div>
      </div>;
  }
  const buyNow = () => {
    haptics.impact();
    if (!isInCart) addToCart({
      id: productId,
      name: product.name,
      price: product.price,
      image: product.images[0],
      brand: product.brand
    });
    navigate('/checkout');
  };
  return <div className="fixed inset-x-0 bottom-[68px] z-40 border-t border-brand-border bg-white shadow-lg lg:hidden" data-id="element-4965" data-mp="3r0oxqv4xigt">
      <div className="px-4 py-3" data-id="element-4966" data-mp="3l8l4irpi42ir">
        {!isInCart ? <div className="flex items-center gap-2" data-id="element-4967" data-mp="3q63gkqytexuz">
            <button type="button" onClick={addProduct} disabled={!product.inStock} className="flex flex-1 items-center justify-center gap-2 rounded-lg border-2 border-brand bg-white px-4 py-3 font-bold text-brand transition-colors duration-150 hover:bg-brand-light disabled:cursor-not-allowed disabled:border-gray-300 disabled:bg-gray-100 disabled:text-gray-500" data-id="element-4968" data-mp="3q6mpji6hmbwv">
              <ShoppingCartIcon className="h-5 w-5" aria-hidden="true" data-id="element-4969" data-mp="cqno060e6c6p" /> Add to Cart
            </button>
            <button type="button" onClick={buyNow} className="flex-1 rounded-lg bg-brand px-4 py-3 font-bold text-white transition-colors duration-150 hover:bg-brand-dark" data-id="element-4970" data-mp="2shjmmiufbsvj">Buy Now</button>
          </div> : <div className="flex items-center gap-2" data-id="element-4971" data-mp="1fihrg6vojchy">
            <div className="flex flex-1 items-center rounded-lg border-2 border-brand bg-brand text-white" data-id="element-4972" data-mp="1al84cxvrjcxa">
              <button type="button" onClick={decreaseQuantity} className="flex-1 rounded-l-lg p-2.5 transition-colors duration-150 hover:bg-brand-dark" aria-label="Decrease quantity" data-id="element-4973" data-mp="1ol94uc848ic8"><MinusIcon className="mx-auto h-5 w-5" data-id="element-4974" data-mp="1khb8g9a6dlmv" /></button>
              <span className="min-w-[50px] border-x-2 border-brand-dark px-3 py-2 text-center font-bold" data-id="element-4975" data-mp="wucqt8abk7nd">{quantity}</span>
              <button type="button" onClick={increaseQuantity} className="flex-1 rounded-r-lg p-2.5 transition-colors duration-150 hover:bg-brand-dark" aria-label="Increase quantity" data-id="element-4976" data-mp="rsdps521xmtl"><PlusIcon className="mx-auto h-5 w-5" data-id="element-4977" data-mp="10ud7kzkw4uxl" /></button>
            </div>
            <button type="button" onClick={buyNow} className="flex-1 rounded-lg bg-brand px-4 py-3 font-bold text-white transition-colors duration-150 hover:bg-brand-dark" data-id="element-4978" data-mp="d4snuegwxtn9">Buy Now</button>
          </div>}
      </div>
    </div>;
}